import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import useBudgetExpenseChart from "./useBudgetExpenseChart";
import { FormSectionHeader, Loader } from "@/components";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  interaction: {
    mode: "index" as const,
    intersection: false,
  },
  plugins: {
    legend: {
      position: "top" as const,
      labels: {
        usePointStyle: true,
        pointStyle: "circle",
      },
      tooltip: {
        usePointStyle: true,
      },
    },
  },
};

const BudgetExpenseChart = () => {
  const { isChartDataLoading, chartData, currentFinanceYear } =
    useBudgetExpenseChart();

  return (
    <div className="bg-white rounded-lg p-[20px]">
      <FormSectionHeader>
        Budget Expense vs Actual Expense(Year: {currentFinanceYear})
      </FormSectionHeader>
      {isChartDataLoading ? (
        <Loader />
      ) : (
        <Bar options={options} data={chartData} />
      )}
    </div>
  );
};

export default BudgetExpenseChart;
